export default {
  dashboard: 'DASHBOARD',
  userAdmin: 'USER_ADMIN',
  globalRoleGranting: 'GLOBAL_ROLE_GRANTING',
  userRolesAdmin: 'USER_ROLES_ADMIN',
  defaultRoleAdmin: 'DEFAULT_ROLE_ADMIN',
  editLocation: 'EDIT_LOCATION',
  addLocation: 'ADD_LOCATION',
  companyAdmin: 'COMPANY_ADMIN',
  addCompanies: 'ADD_COMPANIES',
  editCompanies: 'EDIT_COMPANIES',
  granburyUser: 'GRANBURY_USER',
  engineeringUser: 'ENGINEERING_USER',
  viewApiCreds: 'VIEW_API_CREDS',
  apiCredAdmin: 'API_CRED_ADMIN',
  manageMenuTemplates: 'MANAGE_MENU_TEMPLATES',
  manageMenus: 'MANAGE_MENUS',
  overrideMenus: 'OVERRIDE_MENUS',
  manageLocalItems: 'MANAGE_LOCAL_ITEMS',
  manageOnline: 'MODIFY_ONLINE_ORDERING_CONFIGURATION',
  limitedManageOnline: 'LIMITED_MANAGE_ONLINE',
  pushNotifications: 'PUSH_NOTIFICATIONS',
  setCustomCss: 'SET_CUSTOM_CSS',
  tolLicense: 'TOL_LICENSE',
  deliveryLicense: 'DELIVERY_LICENSE',
  tableServiceLicense: 'TABLE_SERVICE_LICENSE',
  loyaltyLicense: 'LOYALTY_LICENSE',
  accessConfigurationOptions: 'ACCESS_CONFIGURATION_OPTIONS',
  locationLicensing: 'LOCATION_LICENSING',
  hasTolAdminAccess: 'HAS_TOL_ADMIN_ACCESS',
  locationSettings: 'LOCATION_SETTINGS',
  configureHardware: 'CONFIGURE_HARDWARE',
  configureCreditCards: 'CONFIGURE_CREDIT_CARDS',
  overridePriceAndTax: 'OVERRIDE_PRICE_AND_TAX',
  overridePrintingAndKPS: 'OVERRIDE_PRINTING_AND_KPS',
  changePrinterSetting: 'CHANGE_PRINTER_SETTING',
  viewWageData: 'VIEW_WAGE_DATA',
  payroll: 'PAYROLL',
  integrationsSetup: 'INTEGRATIONS_SETUP'
}
